import { ITableColumn } from '../../../@core-ui';

export enum EStatisticsIndices {
	AMEX = 'AMEX',
	DJIA = 'DJIA',
	NASDAQ = 'NASDAQ',
	NYSE = 'NYSE',
}
export const StatisticsIndicesDropdownConstants = [
	{ key: 'AMEX', value: 'AMEX' },
	{ key: 'DJIA', value: 'DJIA' },
	{ key: 'NASDAQ', value: 'NASDAQ' },
	{ key: 'NYSE', value: 'NYSE' },
];

export interface IStatisticsTable {
	Index: string;
	NewHighs?: number;
	NewLows?: number;
	AdvancingIssues?: number;
	DecliningIssues?: number;
	UnchangingIssues?: number;
}

export const StatisticsColumns: ITableColumn<IStatisticsTable>[] = [
	{ header: 'Index', accessor: 'Index', sortDir: 'asc', key: 'Index' },
	{
		header: 'New Highs',
		accessor: 'NewHighs',
		sortDir: 'desc',
		key: 'NewHighs',
	},
	{ header: 'New Lows', accessor: 'NewLows', sortDir: 'desc', key: 'NewLows' },
	{
		header: 'Advancing Issues',
		accessor: 'AdvancingIssues',
		sortDir: 'desc',
		key: 'AdvancingIssues',
	},
	{
		header: 'Declining Issues',
		accessor: 'DecliningIssues',
		sortDir: 'desc',
		key: 'DecliningIssues',
	},
	{
		header: 'Unchanging Issues',
		accessor: 'UnchangingIssues',
		sortDir: 'desc',
		key: 'UnchangingIssues',
	},
];

export interface IStatisticsMobileTable {
	IndexKey: string;
	IndexValue?: number;
}

export const StatisticsMobileViewColumns: ITableColumn<IStatisticsMobileTable>[] =
	[
		{ header: 'IndexKey', accessor: 'IndexKey' },
		{ header: 'IndexValue', accessor: 'IndexValue' },
	];

export const StatisticsXidMapping = [
	{
		xid: 17826012,
		ticker: 'MKT.HIGH-ASE',
		indexName: EStatisticsIndices.AMEX,
	},
	{
		xid: 17826015,
		ticker: 'MKT.LOW-ASE',
		indexName: EStatisticsIndices.AMEX,
	},
	{
		xid: 7780680,
		ticker: 'MKT.ADV-ASE',
		indexName: EStatisticsIndices.AMEX,
	},
	{
		xid: 7780688,
		ticker: 'MKT.DEC-ASE',
		indexName: EStatisticsIndices.AMEX,
	},
	{
		xid: 10545163,
		ticker: 'MKT.UNC-ASE',
		indexName: EStatisticsIndices.AMEX,
	},
	{
		xid: 19892936,
		ticker: 'MKT.HIGH-DJX',
		indexName: EStatisticsIndices.DJIA,
	},
	{
		xid: 19892937,
		ticker: 'MKT.LOW-DJX',
		indexName: EStatisticsIndices.DJIA,
	},
	{
		xid: 19892938,
		ticker: 'MKT.ADV-DJX',
		indexName: EStatisticsIndices.DJIA,
	},
	{
		xid: 19892941,
		ticker: 'MKT.DEC-DJX',
		indexName: EStatisticsIndices.DJIA,
	},
	{
		xid: 19892945,
		ticker: 'MKT.UNC-DJX',
		indexName: EStatisticsIndices.DJIA,
	},
	{
		xid: 567229,
		ticker: 'MKT.HIGH-NAS',
		indexName: EStatisticsIndices.NASDAQ,
	},
	{
		xid: 20573995,
		ticker: 'MKT.LOW-NAS',
		indexName: EStatisticsIndices.NASDAQ,
	},
	{
		xid: 20573996,
		ticker: 'MKT.ADV-NAS',
		indexName: EStatisticsIndices.NASDAQ,
	},
	{
		xid: 20573997,
		ticker: 'MKT.DEC-NAS',
		indexName: EStatisticsIndices.NASDAQ,
	},
	{
		xid: 20573998,
		ticker: 'MKT.UNC-NAS',
		indexName: EStatisticsIndices.NASDAQ,
	},
	{
		xid: 17826013,
		ticker: 'MKT.HIGH-NYS',
		indexName: EStatisticsIndices.NYSE,
	},
	{
		xid: 17826016,
		ticker: 'MKT.LOW-NYS',
		indexName: EStatisticsIndices.NYSE,
	},
	{
		xid: 10025197,
		ticker: 'MKT.ADV-NYS',
		indexName: EStatisticsIndices.NYSE,
	},
	{
		xid: 10025198,
		ticker: 'MKT.DEC-NYS',
		indexName: EStatisticsIndices.NYSE,
	},
	{
		xid: 10544868,
		ticker: 'MKT.UNC-NYS',
		indexName: EStatisticsIndices.NYSE,
	},
];
